// extracted by mini-css-extract-plugin
export default {"ebitda":"style_ebitda__6zrtM","collapse":"style_collapse__xV2Bz"};